import React, { useState } from "react";
import { editShabaPostAPI } from "../../../../Api/PanelAdminServices";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";
import Style from "./ShabaModal.module.scss";
const ShabaModal = ({ data ,type}) => {
  const [iban, setIban] = useState();
  const [disable, setDisable] = useState(false);
  const sendShaba = () => {
    setDisable(true)
    let info = {
      id: data.id,
      user_type:type,
      iban: iban,
    };
    editShabaPostAPI(info, (res) => {
      if (res.status === 1) {
        succToast("باموفقیت ثبت شد")
        setDisable(false)
      }else{
        errorToast(res.message)
        setDisable(false)
      }
    });
  };
  return (
    <div className={Style.componentHolder}>
      <label>شماره شبا</label>
      <input
        defaultValue={data.iban}
        className={Style.shabaInput}
        type={"text"}
        onChange={(e) => setIban(e.target.value)}
      />
      <button className={Style.Btn} onClick={sendShaba} disabled={disable}>
        ثبت
      </button>
    </div>
  );
};

export default ShabaModal;
